export default __webpack_public_path__ + "static/media/img_mamun.384508a4.png";